var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPepiconsPencilPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pepicons-pencil:pen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9442 11.7905C3.96058 11.6855 4.00996 11.5885 4.0852 11.5135L14.1632 1.43546C14.257 1.34172 14.3841 1.28906 14.5167 1.28906C14.6493 1.28906 14.7764 1.34172 14.8702 1.43546L18.7602 5.32546C18.8536 5.41918 18.9061 5.54612 18.9061 5.67846C18.9061 5.81079 18.8536 5.93773 18.7602 6.03146L8.6802 16.1105C8.60505 16.1853 8.50804 16.2344 8.4032 16.2505L3.8082 16.9565C3.73062 16.9684 3.65132 16.9618 3.57674 16.9374C3.50215 16.9129 3.43437 16.8713 3.37887 16.8158C3.32337 16.7603 3.28172 16.6925 3.25728 16.6179C3.23284 16.5433 3.2263 16.464 3.2382 16.3865L3.9432 11.7925L3.9442 11.7905ZM4.9082 12.1045L4.3312 15.8645L8.0902 15.2865L17.6982 5.67846L14.5172 2.49646L4.9082 12.1045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4725 8.17355L11.9355 4.64355L12.6425 3.93555L16.1785 7.46555L15.4725 8.17355Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepiconsPencilPen);
export default __webpack_public_path__ + "static/media/pepicons-pencil_pen.41024e2634752dfc41abf39a0ef3e300.svg";
export { ForwardRef as ReactComponent };